import { post } from "@api/httpClient";

export type ApplicantWebcamEventPayload = {
  eventType: "webcam-started" | "webcam-stopped" | "webcam-unavailable";
  challengeResultId: number;
  mediaDeviceId?: string; // (optional) MediaDeviceInfo.deviceId, only populated for webcam-started events
  mediaDeviceLabel?: string; // (optional) MediaDeviceInfo.label, only populated for webcam-started events
};

interface ApplicantWebcamEventParams {
  applicantExamId: number;
  payload: ApplicantWebcamEventPayload;
}

export async function postWebcamEvent({
  applicantExamId,
  payload,
}: ApplicantWebcamEventParams) {
  const { data } = await post(
    `/api/applicants/exams/${applicantExamId}/webcam/event`,
    {
      data: payload,
    },
  );

  return data;
}

export type ApplicantWebcamScreenshotPayload = {
  connected: boolean;
};

interface ApplicantWebcamGetUploadUrlParams {
  applicantExamId: number;
}

export interface ApplicantWebcamGetUploadUrl {
  // expiry time is set to 40 minutes after the initial call
  expires: string; // "2024-09-20T07:31:18Z"
  uploadUrls: {
    url: string; // "https://track-contents-dev-test.s3-ap-northeast-1.amazonaws.com/";
    /**
     * Fields that we need to pass when uploading to s3. These are set by backend and can be changed at any time
     */
    fields: {
      "Content-Type": string; // "image/jpeg"
      Policy: string; // "eyJleHBpcmF0a...WRhdCIsIjIwIl1dfQ=="
      "X-Amz-Algorithm": string; // "AWS4-HMAC-SHA256"
      "X-Amz-Credential": string; // "ASIAVIKIYQOS5WTBEUWD/20240920/ap-northeast-1/s3/aws4_request"
      "X-Amz-Date": string; // "20240920T065518Z"
      "X-Amz-Security-Token": string; // "IQoJb3Jp...Z17aJ3nne1JxQ=="
      "X-Amz-Signature": string; // "c05fac923f3f3099b4235c6630...b4638bf28826b08"
      bucket: string; // "track-webcam-dev"
      key: string; // "exams/16268/submissions/119903/831d6ff158804a25a493bf132930cac5/snapshots/01920e36-b0f6-7602-bd91-351e4c2dbead.jpg"
      "x-amz-meta-generatedat": string; // "1726815318262"
      "x-amz-meta-requesterinfo": string; // "eyJyZXF1ZXN0SXAiOiIxMTEuMTA4LjIxNy4xNSIsInJlcXVlc3RVc...xORzBKUzl4QzdmMXJtNzA9In0="
    };
    /**
     * Other required fields
     * capturedat will the timestamp of the image's capture time
     */
    otherRequiredFields: string[]; // ["x-amz-meta-capturedat"]
  }[];
}

export interface ApplicantWebcamGetUploadUrlResponse {
  code: number;
  result: ApplicantWebcamGetUploadUrl;
}

/**
 * gets a signed links to upload to s3
 */
export async function postWebcamGetUrls({
  applicantExamId,
}: ApplicantWebcamGetUploadUrlParams): Promise<ApplicantWebcamGetUploadUrlResponse> {
  const { data } = await post<ApplicantWebcamGetUploadUrlResponse>(
    `/api/applicants/exams/${applicantExamId}/webcam/snapshot-upload-urls`,
  );

  return data;
}
